export default __webpack_public_path__ + "static/media/LFEX-icon.ae1a54e0.png";